import { TfaComponent } from './tfa/tfa.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { ZendeskSSOComponent } from './login-zendesk-sso/login-zendesk-sso.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { InputTypePipe } from './pipes/input-type.pipe';
import { CamelToSpacesPipe } from './pipes/camel-to-spaces.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { UiSharedModule } from '@shared/ui-shared.module';
import { InputLabelPipe } from './pipes/input-label.pipe';
import { SetPasswordComponent } from './set-password/set-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LoginssoComponent } from './loginsso/loginsso.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { authFeatureKey, authReducer } from '@app/auth/store/auth.reducer';
import { AuthEffects } from '@app/auth/store/auth.effects';

@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    ZendeskSSOComponent,
    ResetPasswordComponent,
    InputTypePipe,
    CamelToSpacesPipe,
    TfaComponent,
    InputLabelPipe,
    SetPasswordComponent,
    ChangePasswordComponent,
    LoginssoComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    UiSharedModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatCheckboxModule,
    StoreModule.forFeature(authFeatureKey, authReducer),
    EffectsModule.forFeature([AuthEffects]),
  ],
})
export class AuthModule {}
